/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useCallback} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {getLaundryCost} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {
  LaundryCostModel,
  LaundryFilterReportModel,
} from '../../../../features/laundryBilling/model/laundryBilling.model'

interface PropsTable {
  validation?: boolean
  conditional?: boolean
  search?: any
}
const TableLaundryCost: FC<PropsTable> = ({conditional, search}) => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {isAllowed} = useLavanderia()
  const getLaundryList = useCallback(
    async (props: LaundryFilterReportModel = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryCost({...props}, pagination.currentPage)
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    },
    [setLoading, setData, pagination.currentPage],
  )

  const columns: Column<LaundryCostModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Empresa' />,
        accessor: 'empresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Centro de costo' />,
        accessor: 'centroCostos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso (Kg.)' />,
        accessor: 'totalKg',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total (S/.)' />,
        accessor: 'TotalPrecio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total de prendas' />,
        accessor: 'totalPrendas',
      },
    ],
    [data],
  )

  useEffect(() => {
    getLaundryList(search)
  }, [pagination.currentPage])

  useEffect(() => {
    if (conditional) {
      getLaundryList(search)
    }
  }, [conditional])
  return (
    <>
      {isAllowed('CECO/LISTAR') && (
        <KTCard shadow className='m-5'>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <KTable data={data} columns={columns} />
        </KTCard>
      )}
    </>
  )
}

const TableLaundryCostWrapper: FC<PropsTable> = ({validation, search}) => {
  return (
    <KTableProvider>
      <TableLaundryCost conditional={validation} search={search} />
    </KTableProvider>
  )
}

export {TableLaundryCostWrapper}
